'use client';
import { imageData } from '@/config/defaultBlur';
import { PAGE_QUERYResult } from '@/sanity.types';
import { urlForImage } from '@/sanity/lib/utils';
import Image from 'next/image';
import React, { useEffect, useState } from 'react';
import { Carousel, Col, Row } from 'react-bootstrap';
import './cardDisplay.scss';
import Link from 'next/link';

type wideCarouselType = Extract<
  NonNullable<NonNullable<PAGE_QUERYResult>['content']>[number],
  { _type: 'wideCarousel' }
>;

type sidesType = wideCarouselType['slides'];

type CarouselDisplayProps = {
  slides: sidesType;
};
const chunkSlides = (slides: sidesType, chunkSize: number) => {
  const chunks = [];
  if (slides) {
    for (let i = 0; i < slides.length; i += chunkSize) {
      chunks.push(slides.slice(i, i + chunkSize));
    }
  }
  return chunks;
};
export const CardDisplay = ({ slides }: CarouselDisplayProps) => {
  const [chunkSize, setChunkSize] = useState(3);

  useEffect(() => {
    const updateChunkSize = () => {
      const width = window.innerWidth;
      if (width < 576) {
        setChunkSize(1);
      } else if (width < 768) {
        setChunkSize(2);
      } else {
        setChunkSize(3);
      }
    };

    updateChunkSize();
    window.addEventListener('resize', updateChunkSize);

    return () => window.removeEventListener('resize', updateChunkSize);
  }, []);

  const chunkedSlides = chunkSlides(slides, chunkSize);

  return (
    <Carousel
      slide
      className="card-carousel"
      controls={slides ? slides.length > 3 : false}
      indicators={slides ? slides.length > 3 : false}
    >
      {chunkedSlides.map((chunk, index) => {
        return (
          <Carousel.Item key={index}>
            <Row>
              {chunk.map((slide, slideIndex) => (
                <Col
                  xs={12}
                  sm={6}
                  md={4}
                  className="carousel-image"
                  key={`item-${slideIndex}`}
                >
                  <div className="slide-item">
                    <Link href={slide?.link || ''}>
                      <Image
                        src={
                          slide?.wideCarouselImage
                            ? (urlForImage(
                                slide.wideCarouselImage
                              )?.url() as string)
                            : ''
                        }
                        alt={slide?.wideCarouselImage?.alt || ''}
                        // sizes="25vw"
                        width={600}
                        height={600}
                        className="carousel-small-image fade-in-out"
                        placeholder="blur"
                        blurDataURL={
                          slide?.wideCarouselImage?.imgAsset?.metadata?.lqip ||
                          imageData.blurImage
                        }
                      />
                      {(slide?.title || slide?.Description) && (
                        <Carousel.Caption>
                          <div className="caption">
                            {/* <Link href={slide?.link || ''}> */}
                            <h4>{slide?.title}</h4>
                            {/* </Link> */}
                            <p>{slide?.Description}</p>
                          </div>
                        </Carousel.Caption>
                      )}
                    </Link>
                  </div>
                </Col>
              ))}
            </Row>
          </Carousel.Item>
        );
      })}
    </Carousel>
  );
};
